import { GOAL_TYPE } from './goals';
export let NETWORK_LOGO;

(function (NETWORK_LOGO) {
  NETWORK_LOGO["ADWORDS"] = "google-ads";
  NETWORK_LOGO["FACEBOOK"] = "facebook";
  NETWORK_LOGO["LINKEDIN"] = "linkedin";
})(NETWORK_LOGO || (NETWORK_LOGO = {}));

export let LIFECYCLE_STAGE;

(function (LIFECYCLE_STAGE) {
  LIFECYCLE_STAGE["LEAD"] = "lead";
  LIFECYCLE_STAGE["MARKETING_QUALIFIED_LEAD"] = "marketingqualifiedlead";
  LIFECYCLE_STAGE["SALES_QUALIFIED_LEAD"] = "salesqualifiedlead";
  LIFECYCLE_STAGE["OPPORTUNITY"] = "opportunity";
  LIFECYCLE_STAGE["CUSTOMER"] = "customer";
})(LIFECYCLE_STAGE || (LIFECYCLE_STAGE = {}));

export const LIFECYCLE_STAGE_GOALS_TO_ADS = {
  [LIFECYCLE_STAGE.LEAD]: 'leads',
  [LIFECYCLE_STAGE.MARKETING_QUALIFIED_LEAD]: 'marketingQualifiedLeads',
  [LIFECYCLE_STAGE.SALES_QUALIFIED_LEAD]: 'salesQualifiedLeads',
  [LIFECYCLE_STAGE.OPPORTUNITY]: 'opportunities',
  [LIFECYCLE_STAGE.CUSTOMER]: 'customers'
};
export const NO_DATA_LANG_LABEL = 'goals-reporting-lib.detailsPanel.adspend.n_a';
export const ADS_GOAL_TYPES = [GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE, GOAL_TYPE.FIRST_FORM_SUBMISSION, GOAL_TYPE.NUMBER_OF_CONTACTS_IN_LIFECYCLE, GOAL_TYPE.NUMBER_OF_NETWORK_CONVERSIONS];
export const MAX_AD_CAMPAIGNS_IN_CONSOLE_TABLE_CELL = 5;